import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";



export const getTrendingMovies = createAsyncThunk("movies/getTrendingMovies", async() => {
    const {data} = await axios.get(`https://api.themoviedb.org/3/trending/movie/week?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5`)
    return data;
})





const tmSlice = createSlice({
    name:"trendingMovies",
    initialState:{
        data: null,
        isloading: false,
        error: null,
    },
    reducers:{},
    extraReducers:(builder) =>{
        builder.addCase(getTrendingMovies.pending,(state) => {
            state.isloading = true;
        })
        builder.addCase(getTrendingMovies.fulfilled,(state,action) => {
            state.isloading = false;
            state.data = action.payload
        })
        builder.addCase(getTrendingMovies.rejected,(state,action) => {
            state.isloading = false;
            state.error = action.payload.error
        })
    }
})
export default tmSlice.reducer